import Axios from "api/axios"
import qs from "querystring"
import { history } from "app-history"

export const getListings = async () => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/listings'
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const createListing = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/listings',
      data: form
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const getScoreChanger = async () => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/listings/scorechanger'
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const updateScoreChanger = async (data) => {
  const params = qs.parse(history.location.search)

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PATCH',
      url: '/listings/scorechanger',
      data: {
        listingId: params['?jobId'],
        scorechanger: data,
      }
    })

    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}
